<template>
    <div class="report__dashboard_show_learningactivity">
        <div class="report__dashboard_show_learningactivity_header">
            <component-filters-dashboard-reports
                :filter-key="'learning_activity'"
                @emit-submit-request="performGetData"
                @emit-get-request="performGetData"
            ></component-filters-dashboard-reports>
        </div>
        <div class="report__dashboard_show_learningactivity_main">
            <div class="container">
                <template v-if="requestPending">
                    <component-loading :size="'small'"></component-loading>
                </template>
                <template v-else>
                    <component-wrapper class="report__dashboard_show_learningactivity_main_diagram">
                        <component-title
                            :class="'report__dashboard_show_learningactivity_main_diagram_title'"
                            :size="'large'"
                            :underline="false"
                            :raw="true"
                        >Course completion over time
                        </component-title>
                        <template v-if="completionsDataEmpty">
                            <component-empty-state
                                :title="'No completions to see yet. \n Course completions over time will be displayed here as soon as there is some activity.'"
                                :submit-button-active="false"
                            ></component-empty-state>
                        </template>
                        <template v-else>
                            <div class="columns is-vcentered">
                            <div class="column is-narrow">
                                <div class="report__dashboard_show_learningactivity_main_diagram_label">Course completions</div>
                            </div>
                            <div class="column">
                                <component-chart
                                    ref="chartcoursecompletions"
                                    :name="'report-dashboard-course-completions'"
                                    :series="[
                                    {
                                        name: 'Completions',
                                        data: completionsData.series
                                    }
                                    ]"
                                    :type="'bar'"
                                    :tooltip="{
                                      x: {
                                        format: filtersDateRange === 'last-12-months' ? 'MMMM' : 'dd MMM'
                                      }
                                    }"
                                    :xaxis="{
                                        type: 'datetime',
                                        categories: completionsData.categories,
                                        labels: {
                                            format: filtersDateRange === 'last-12-months' ? 'MMM' : 'dd MMM'
                                        }
                                    }"
                                    :plot-options="{
                                      bar: {
                                        dataLabels: {
                                          position: 'center'
                                        }
                                      }
                                    }"
                                    :data-labels="{
                                        enabled: true
                                    }"
                                ></component-chart>
                            </div>
                        </div>
                        </template>
                    </component-wrapper>
                    <component-wrapper class="report__dashboard_show_learningactivity_main_diagram">
                        <component-title
                            :class="'report__dashboard_show_learningactivity_main_diagram_title'"
                            :size="'large'"
                            :underline="false"
                            :raw="true"
                        >Total time spent on digital learning
                        </component-title>
                        <template v-if="totalTimeDataEmpty">
                            <component-empty-state
                                :title="'No training time to see yet. \n Time spent on your courses will be displayed here once there is some activity.'"
                                :submit-button-active="false"
                            ></component-empty-state>
                        </template>
                        <template v-else>
                            <div class="columns is-vcentered">
                            <div class="column is-narrow">
                                <div class="report__dashboard_show_learningactivity_main_diagram_label">Hours</div>
                            </div>
                            <div class="column">
                                <component-chart
                                    ref="chartcoursecompletions"
                                    :name="'report-dashboard-activity-total-time'"
                                    :series="[
                                    {
                                        name: 'Hours',
                                        data: totalTimeData.series
                                    }
                                    ]"
                                    :type="'bar'"
                                    :tooltip="{
                                      x: {
                                        format: filtersDateRange === 'last-12-months' ? 'MMMM' : 'dd MMM'
                                      }
                                    }"
                                    :xaxis="{
                                        type: 'datetime',
                                        categories: totalTimeData.categories,
                                        labels: {
                                            format: filtersDateRange === 'last-12-months' ? 'MMM' : 'dd MMM'
                                        }
                                    }"
                                    :plot-options="{
                                      bar: {
                                        dataLabels: {
                                          position: 'center'
                                        }
                                      }
                                    }"
                                    :data-labels="{
                                        enabled: true
                                    }"
                                ></component-chart>
                            </div>
                        </div>
                        </template>
                    </component-wrapper>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentFiltersDashboardReports from '@/components/default/shared/ComponentFiltersDashboardReports'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import ComponentChart from '@/components/default/shared/ComponentChart'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'

export default {
  name: 'report-dashboard-show-learning-activity',
  components: {
    ComponentEmptyState,
    ComponentWrapper,
    ComponentChart,
    ComponentTitle,
    ComponentLoading,
    ComponentFiltersDashboardReports
  },
  data () {
    return {
      requestPending: true
    }
  },
  computed: {
    filtersDateRange () {
      const learningActivityFilter = this.$store.getters.getEbsReportDashboardFiltersLearningActivity
      const filterRange = learningActivityFilter.find(obj => obj.key === 'dates').values.range

      return filterRange
    },
    completionsData () {
      const rawData = this.$store.getters.getEbsReportDashboardDataLearningActivityCompletions
      const series = Object.values(rawData)
      const categories = Object.keys(rawData)

      return { series, categories }
    },
    completionsDataEmpty () {
      return Number(this.completionsData.series.reduce((a, b) => a + b, 0)) === 0
    },
    totalTimeData () {
      const rawData = this.$store.getters.getEbsReportDashboardDataLearningActivityTotalTime
      const series = Object.values(rawData)
      const categories = Object.keys(rawData)

      return { series, categories }
    },
    totalTimeDataEmpty () {
      return Number(this.totalTimeData.series.reduce((a, b) => a + b, 0)) === 0
    }
  },
  methods: {
    performGetData () {
      this.requestPending = true
      this.$store.dispatch('ebsReportDashboardGetDataLearningActivity').finally(() => {
        this.requestPending = false
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboardlearningactivity.scss";
</style>
